import { ChangeEvent, FC } from 'react';
import { Collapse, FormControlLabel, Radio, RadioGroup, useTheme } from '@mui/material';

import { pxToRem } from '@/theme/typography';

export interface DropDownItemModel {
  id: number;
  value: string;
}

interface SideMenuDropdownProps {
  isOpen: boolean;
  dropDownTitle: string;
  selectedValue: number;
  data: DropDownItemModel[];
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onTransitionEnter: () => void;
  onTransitionExited: () => void;
}

export const SideMenuDropdown: FC<SideMenuDropdownProps> = ({
  isOpen,
  dropDownTitle,
  selectedValue,
  data,
  onChange,
  onTransitionEnter,
  onTransitionExited,
}) => {
  const theme = useTheme();

  return (
    <Collapse
      in={isOpen}
      timeout='auto'
      onEnter={onTransitionEnter}
      onExited={onTransitionExited}
    >
      <RadioGroup
        aria-labelledby={dropDownTitle}
        name={`${dropDownTitle}-group`}
        value={selectedValue}
        onChange={onChange}
        sx={{
          paddingX: '14px',
          paddingTop: '13px',
          paddingBottom: '8px',
        }}
      >
        {data.map(({ id, value }) => (
          <FormControlLabel
            key={id}
            value={id}
            control={<Radio className='custom-secondary' />}
            label={value}
            sx={{
              color: theme.palette.common.white,
              margin: '0px',
              paddingY: '18.5px',
              borderBottom: `1px solid ${theme.palette.common.white}`,
              '& .MuiRadio-root': {
                padding: '0px',
                marginRight: '16px',
              },
              '& .MuiFormControlLabel-label': {
                fontSize: pxToRem(18),
                letterSpacing: pxToRem(0.1),
              },
              '&:first-of-type': {
                paddingTop: '0px',
              },
              '&:last-of-type': {
                paddingBottom: '0px',
                border: 'none',
              },
            }}
          />
        ))}
      </RadioGroup>
    </Collapse>
  );
};
